import type { AmplifierLocaleKey } from '../../i18n/amplifier/locales';
import type { AmplifierTranslateParams } from '../../i18n/amplifier/amplifierI18nService';

/** alarm_word 位图对应的 11 项报警标签 key（bit 0..10） */
export const AMPLIFIER_ALARM_LABEL_KEYS = [
    '输入正向功率保护',
    '输入反向功率保护',
    '功放管输入过电压保护',
    '功放管输出过电压保护',
    '功放输出正向功率保护',
    '功放管输出反向功率保护',
    '过流保护',
    '过压保护',
    '过温保护',
    '高驻波',
    '频率误差过大',
] as const satisfies readonly AmplifierLocaleKey[];

/** @deprecated 使用 AMPLIFIER_ALARM_LABEL_KEYS + getActiveAlarmLabels */
export const AMPLIFIER_ALARM_LABELS = AMPLIFIER_ALARM_LABEL_KEYS;

export function getActiveAlarmLabels(
    alarmWord: number,
    t: (key: AmplifierLocaleKey, params?: AmplifierTranslateParams) => string,
): string[] {
    if (!alarmWord) return [];
    return AMPLIFIER_ALARM_LABEL_KEYS.filter((_, i) => (alarmWord & (1 << i)) !== 0).map((key) => t(key));
}

export function hasActiveAlarm(alarmWord: number | undefined | null): boolean {
    return (alarmWord ?? 0) !== 0;
}
